import { Globe, path } from "@hscmap/stellar-globe";
import axios from 'axios'

export class AreaRenderer extends path.Renderer {
  constructor(readonly globe: Globe, public url: string) {
    super(globe.gl);
    this.setUrl(url)
  }

  setUrl(url: string) {
    this.url = url
    this.load()
  }

  private async load() {
    const fail = { data: [] }
    const { url } = this
    const { data: region } = await axios.get<number[][][]>(url).catch((e) => fail)
    if (this.url !== url) {
      return
    }
    const width = 0.01;
    const color: [number, number, number, number] = [0, 0.75, 0, 1];
    const paths: path.Path[] = [];
    for (const piece of region) {
      const p = new path.Path(piece.map((v) => new path.Point(v as any, color, width)), true, path.JOINT.MITER);
      paths.push(p);
    }
    this.setPaths(paths);
    this.globe.requestRefresh();
  }
}
